<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="image"><img alt="image" src="images/pg4_1.jpg"/></p>
<p class="pagebreak"> </p>
<p class="toc-title" id="sec">Contents</p>
<p class="toc"><a href="#/xhtml/introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01">The Game of the Goose and Other Animals</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">The Game of the Owl and Other Lotteries</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Educational Games: Learning for Pleasure?</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Morals and Religion: How to Behave!</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Journeys: Where Shall We Go?</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Games of War, Siege and Joust: Contests of the Imagination</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Sports and Leisure: Enjoy the Fun!</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Satire and Polemic: Games with a Bite!</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Advertising and Promotion: Games with a Message</span></p>
<p class="toc" style="margin-bottom:0em;"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Board Games Go to America: the Quest for the New</span></p>
<p class="image" style="margin-top:3.5em;"><img alt="image" src="images/common.jpg" style="height:3.5em;"/></p>
<p class="toc">Game of Harlequin. Amsterdam: Vlieger, about 1890</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a0ebab2c